import {Pipe, PipeTransform} from '@angular/core';
import {UtilitiesService} from '../../core/_services/utilities.service';
import {PAYMENT_TYPE} from '../../core/constants';
import {PaymentMethod} from '../_models/paymentmethod';
import {OrgContext} from "../_models/role";

@Pipe({
    name: 'paymentAlias'
})
export class PaymentAliasPipe implements PipeTransform {

    /**
     * @param value - an array of payment methods
     * @param markPreferred - appends preferred payment methods with (default)
     * @returns {any} - returns payment methods with set paymentAlias property
     */
    transform(value: PaymentMethod[], markPreferred?: boolean): any {
        if (!UtilitiesService.isEmpty(value)) {
            value.forEach(function (paymentMethod: PaymentMethod) {
                let alias: string;

                if (paymentMethod.paymentType === PAYMENT_TYPE.CREDITCARD) {
                    switch (paymentMethod.cardType) {
                        case 1:
                            alias = 'Visa';
                            break;
                        case 2:
                            alias = 'MasterCard';
                            break;
                        case 3:
                            alias = 'Discover';
                            break;
                        case 4:
                            alias = 'American Express';
                            break;
                        default:
                            alias = 'Unknown';
                            break;
                    }
                    alias += ' ending in ' + paymentMethod.last4;
                } else {
                    alias = paymentMethod.typeName;
                }

                if (markPreferred && paymentMethod.preferred) {
                    alias = `Default (${alias})`;
                }

                paymentMethod.paymentAlias = alias;

                return paymentMethod;
            });
        }
        return value || [];
    } // transform()

    filter(methods: PaymentMethod[], userId: number, includeVehicle: boolean, selectedRoleOrgContext: OrgContext) {
        if (UtilitiesService.isNotEmpty(methods)) {
            let paymentMethods = methods
            // filter out payment methods associated to a vehicle
                .filter((pm) => includeVehicle || !pm.vehicleId);

            paymentMethods = UtilitiesService.isNotEmpty(selectedRoleOrgContext)
                ? paymentMethods // no need to filter..backend will send appropriate payment methods
                : paymentMethods.filter((pm) => pm.userId === userId);

            // minion has no payment methods, show master's default
            if (!paymentMethods.length) {
                const masterPaymentMethod = methods.find((pm) => !pm.vehicleId && pm.userId !== userId && pm.preferred);
                if (masterPaymentMethod) {
                    paymentMethods.push(masterPaymentMethod);
                }
            }

            return paymentMethods;
        }

        return methods;
    } // filter()

} // PaymentAliasPipe
